export default __webpack_public_path__ + "static/media/logo_bv.e8124b13.jpeg";